export const API_URL = {
    'masterData.all': 'cmt/category',
    'masterData.store': 'cmt/category/create',
    'masterData.update': 'cmt/category/update/:id',
    'masterData.delete': 'cmt/category/delete/:id',
}
